import { AdvertisingSlot } from 'react-advertising'

import { StyledTopSlotWrapper } from '@/components-page/srp/advertisement/styled'

type TopSlotWrapperProps = {
  id: string
}

export const TopSlotWrapper = ({ id, ...props }: TopSlotWrapperProps) => {
  return (
    <StyledTopSlotWrapper>
      <AdvertisingSlot id={id} {...props} />
    </StyledTopSlotWrapper>
  )
}
